@if(this.isThemedStreamView) {
    <app-themed-stream-view
        [match]="match"
        [tie]="tie"
        [isRetiredOrIncomplete]="isRetiredOrIncomplete()"
        [showPoints]="showPoints()"
        [side1Color]="side1Color"
        [side2Color]="side2Color"
        [statusSide1]="getStatus(2)"
        [statusSide2]="getStatus(1)"
        [pointScoreSide1]="getPointScore(1)"
        [pointScoreSide2]="getPointScore(2)"
        [server]="match.score?.server"
        >
    </app-themed-stream-view>
} @else if (isStreamView) {
    <!-- PLAYSIGHT -->
    <app-playsight
        [match]="match"
        [tie]="tie"
        [isRetiredOrIncomplete]="isRetiredOrIncomplete()"
        [showPoints]="showPoints()"
        [side1Color]="side1Color"
        [side2Color]="side2Color"
        [statusSide1]="getStatus(2)"
        [statusSide2]="getStatus(1)"
        [pointScoreSide1]="getPointScore(1)"
        [pointScoreSide2]="getPointScore(2)"
        [server]="match.score?.server"
        >
    </app-playsight>
} @else if (isTimedTennis) {
    <app-timed-tennis
        [match]="match"
        [pointScoreSide1]="getPointScore(1)"
        [pointScoreSide2]="getPointScore(2)"
        [server]="match.score?.server"
    ></app-timed-tennis>
} @else {
    @if (matchActive) {
        <ion-card class="content-width" [ngClass]="{'selected-scorecard': isSelectedMatch}">
            <div class="sb-wrapper">
                @if (showTrackerBar()) {
                    @if (match.officials?.length) {
                        <div class="official-wrapper">
                            @for (official of match.officials; track $index) {
                                {{ official.type | translate }}: {{ official.user.last_name }}, {{ official.user.first_name }} <br/>
                            }
                            @if (match.matchStatus === "IN_PROGRESS" && match.startDate && !match.endDate) {
                                <div class="date">
                                    {{ match.startDate | date: "h:mm a" }}
                                </div>
                            }
                            @if (match.endDate) {
                                <div class="date">
                                    {{ match.startDate | date: "h:mm a" }} - {{ match.endDate | date: "h:mm a" }}
                                </div>
                            }
                        </div>
                    }
                }
                <div (click)="openMatchTracker()">
                    <app-sb-header [match]="match"></app-sb-header>
                    <app-sb-body [match]="match" [tie]="tie" (addPointOrGame)="addPointOrGame($event)"></app-sb-body>
                </div>

                @if (showTrackerBar()) {
                    <app-tracker-bar 
                        [match]="match" 
                        [isTracker]="isTracker()" 
                        [isOwner]="isOwner" 
                        (undo)="undo.emit()" 
                        (changeScoringTypeEmit)="isPointByPoint = $event" 
                        (stopTimedSet)="completeTimedSet.emit()"
                        [hideMatchMoreOptions]="hideMatchMoreOptions"
                        [venue]="venue"
                        [court]="court">
                    </app-tracker-bar>
                }

                @if (!match._id && !match.winningSide && (isTournamentOwner || isTournamentTracker)) {
                    <app-download-match [match]="match"></app-download-match>
                }

                @if (match._id && isTracker() && (authService.authUserSignal()?.role.value === 111 || authService.authUserSignal()?.role.value === 211)) {
                    <app-ross [match]="match"></app-ross>
                }
            </div>
        </ion-card>
    }
}